/* cc-pdp-notify — main buy button becomes the Stoq notify trigger on
   sold-out variants (Tony 2026-07-11; replaces the app's floating side
   tab, hidden in cc-pdp-notify.css).
   How: whenever Dawn marks the submit button disabled ("Sold out") and
   Stoq's trigger exists, swap the label + re-enable; a capture-phase
   click handler intercepts before the form submit and clicks Stoq's
   hidden .restock-rocket-button-cover. When Dawn re-enables the button
   for an available variant, notify mode clears itself.
   Dawn re-renders the buy-buttons block on variant change (section
   fetch), so re-apply runs on variantChange + optionValueSelectionChange
   with delays (same belt-and-suspenders as cc-variant-filter) — plus
   timed retries at load for Stoq's async injection. NO MutationObserver. */

(() => {
  if (window.ccInitGuardccPdpNotify) return;
  window.ccInitGuardccPdpNotify = true;

  const NOTIFY_LABEL = 'Notify Me When Available';

  const stoqTrigger = () =>
    document.querySelector('.restock-rocket-button-cover') ||
    document.querySelector('.restock-rocket-button-product');

  function apply() {
    const trig = stoqTrigger();
    document.querySelectorAll('.product-form__submit').forEach((btn) => {
      const span = btn.querySelector('span') || btn;
      const dawnSoldOut = btn.hasAttribute('disabled');
      if (dawnSoldOut && trig) {
        btn.dataset.ccNotifyMode = '1';
        btn.removeAttribute('disabled');
        span.textContent = NOTIFY_LABEL;
      } else if (!dawnSoldOut && btn.dataset.ccNotifyMode === '1' && span.textContent.trim() !== NOTIFY_LABEL) {
        /* Dawn re-enabled + relabeled for an available variant */
        delete btn.dataset.ccNotifyMode;
      }
    });
  }

  /* intercept before ProductForm's submit pipeline */
  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest('.product-form__submit');
      if (!btn || btn.dataset.ccNotifyMode !== '1') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const trig = stoqTrigger();
      if (trig) trig.click();
      else console.warn('[cc-pdp-notify] Stoq trigger missing — notify unavailable');
    },
    true
  );

  const reapply = () => {
    [0, 300, 800].forEach((ms) => setTimeout(apply, ms));
  };

  // PUB_SUB_EVENTS is a top-level const (no window property) — bare identifier (2026-10-01)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, reapply);
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, reapply);
  }

  /* Stoq injects async after load */
  [400, 1200, 2500, 4500].forEach((ms) => setTimeout(apply, ms));
})();
